import React ,{useState,useRef}from 'react';
import './accordian.css';
import Chevron from './chevron'
function Accordian(props) {
    const [setActive, setActiveState] = useState("");
    const [setHeight, setHeightState] = useState("0px");
    const [setRotate, setRotateState] = useState("accordian_icon");
  
const content=useRef(null);  
    function toggleaccordian() {
      setActiveState(setActive === "" ? "active" : "");
      setHeightState(
        setActive === "active" ? "0px" : `${content.current.scrollHeight}px`
      );
      setRotateState(
        setActive === "active" ? "accordian_icon" : "accordian_icon rotate"
      );
    }
  
    return (
      <div className="accordian_section">
        <button className={`accordian ${setActive}`} onClick={toggleaccordian}>
          <p className="accordian_title">{props.title}</p>
          <Chevron className={`${setRotate}`} width={10} fill={"#777"} text-align={"align"}/>
        </button>
        <div
          ref={content}
          style={{ maxHeight: `${setHeight}` }}
          className="accordian_content" fontWeight={"normal"}
        >
          <div
            className="accordian_text"
            dangerouslySetInnerHTML={{ __html: props.content }}
          />
        </div>
      </div>
    );
  }
  
export default Accordian;